/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';

/**
 * Trial Expired Banner Component
 * Displays when user's trial period has expired and no active charge exists
 */
const TrialExpiredBanner = ({ show, remainingDays, onDismiss, onUpgrade }) => {
  if (!show) return null;

  const isExpired = remainingDays === 0;
  const title = isExpired 
    ? "Your trial has expired" 
    : `Only ${remainingDays} day(s) left in your trial`;

  const message = isExpired
    ? "Please activate your subscription to continue using this feature."
    : "Please activate your subscription soon to avoid disruption.";

  return (
    <s-box paddingBlockEnd="small">
      <s-banner 
        heading={title}
        tone="info"
        dismissible
        onDismiss={onDismiss}
      >
        <s-paragraph>{message}</s-paragraph>
        <s-button slot="secondary-actions" onClick={onUpgrade}>
          Activate Subscription
        </s-button>
      </s-banner>
    </s-box>
  );
};

export default TrialExpiredBanner;
